import { CaLabeling } from '~/Api/User/ProductGroup/CaLabeling/CaLabeling';
import { mapProduct, RawProduct } from '~/Api/User/ProductGroup/CaLabeling/mapProduct';
import { Reference } from '~/Api/User/ProductGroup/CaLabeling/Reference';

interface RawReference {
	referenceBasketVersion: string;
}

export interface RawCaLabeling {
	_links: { [key: string]: string };
	products: RawProduct[];
	reference: RawReference;
}

export const mapCaLabeling = (caLabeling: RawCaLabeling): CaLabeling => {
	return new CaLabeling(
		caLabeling._links,
		caLabeling.products.map(mapProduct),
		new Reference(caLabeling.reference.referenceBasketVersion)
	);
};
